import React, { useState } from 'react';
import { User, Calendar, MapPin, Mail, Lock, Camera, Edit2, Check, X, Award, Users } from 'lucide-react';
const SPORT_RANKS = ['Без розряду', 'III розряд', 'II розряд', 'I розряд', 'КМС', 'МС', 'МСМК', 'ЗМС'];
const REGIONS = ['Вінницька область', 'Волинська область', 'Дніпропетровська область', 'Донецька область', 'Житомирська область', 'Закарпатська область', 'Запорізька область', 'Івано-Франківська область', 'Київська область', 'Кіровоградська область', 'Луганська область', 'Львівська область', 'Миколаївська область', 'Одеська область', 'Полтавська область', 'Рівненська область', 'Сумська область', 'Тернопільська область', 'Харківська область', 'Херсонська область', 'Хмельницька область', 'Черкаська область', 'Чернівецька область', 'Чернігівська область', 'м. Київ', 'АР Крим'];
const CLUBS = ['Без клубу', 'СК "Вертикаль" (Харків)', 'КАК "Київ-Альп" (Київ)', 'СК "Ельбрус" (Львів)', 'СК "Карпати" (Івано-Франківськ)', 'СК "Скеля" (Дніпро)', 'СК "Гірник" (Запоріжжя)', 'СК "Альпіна" (Одеса)', 'СК "Чорногора" (Ужгород)', 'СК "Говерла" (Київ)', 'СК "Кристал" (Харків)'];
interface UserData {
  firstName: string;
  lastName: string;
  patronymic: string;
  dob: string;
  address: string;
  email: string;
  region: string;
  club: string;
  rankAlpinism: string;
  rankClimbing: string;
  rankIceClimbing: string;
}
const initialData: UserData = {
  firstName: 'Микола',
  lastName: 'Сало',
  patronymic: 'Іванович',
  dob: '1985-05-14',
  address: 'вул. Хрещатик, 22, кв. 45, Київ, 01001',
  email: 'mykola.salo@example.com',
  region: 'Харківська область',
  club: 'СК "Вертикаль" (Харків)',
  rankAlpinism: 'КМС',
  rankClimbing: 'I розряд',
  rankIceClimbing: 'II розряд'
};
function FieldRow({
  label,
  value,
  editing,
  children
}: {
  label: string;
  value?: string;
  editing: boolean;
  children?: React.ReactNode;
}) {
  return <div data-id="element-487">
      <label className="block text-xs font-semibold text-slate-400 uppercase tracking-wide mb-1.5" data-id="element-488">
        {label}
      </label>
      {editing ? children : <p className="text-sm font-medium text-slate-800 py-2 px-3 bg-slate-50 rounded-lg border border-slate-100" data-id="element-489">
          {value}
        </p>}
    </div>;
}
export function ProfileCard() {
  const [data, setData] = useState<UserData>(initialData);
  const [draft, setDraft] = useState<UserData>(initialData);
  const [isEditing, setIsEditing] = useState(false);
  const [isEditingPassword, setIsEditingPassword] = useState(false);
  const [passwordForm, setPasswordForm] = useState({
    current: '',
    next: '',
    confirm: ''
  });
  const handleEdit = () => {
    setDraft({
      ...data
    });
    setIsEditing(true);
  };
  const handleSave = () => {
    setData({
      ...draft
    });
    setIsEditing(false);
  };
  const handleCancel = () => {
    setDraft({
      ...data
    });
    setIsEditing(false);
  };
  const handlePasswordSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsEditingPassword(false);
    setPasswordForm({
      current: '',
      next: '',
      confirm: ''
    });
  };
  const inputClass = 'w-full px-3 py-2 rounded-lg border border-slate-200 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400 transition-all bg-white';
  const selectClass = 'w-full px-3 py-2 rounded-lg border border-slate-200 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400 transition-all bg-white appearance-none cursor-pointer';
  return <div className="space-y-6" data-id="element-490">
      {/* Header / Avatar */}
      <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-[0_4px_24px_rgba(0,0,0,0.04)] border border-slate-100" data-id="element-491">
        <div className="flex flex-col sm:flex-row items-center sm:items-start gap-6" data-id="element-492">
          <div className="relative" data-id="element-493">
            <div className="w-24 h-24 sm:w-28 sm:h-28 rounded-full flex items-center justify-center text-white text-3xl font-bold shadow-md border-4 border-white" style={{
            background: 'linear-gradient(135deg, #3b8fd4, #1d6fa8)'
          }} data-id="element-494">
              {data.firstName[0]}
              {data.lastName[0]}
            </div>
            <button className="absolute bottom-0 right-0 p-2 rounded-full bg-white shadow-md border border-slate-100 text-slate-500 hover:text-blue-600 transition-colors" aria-label="Змінити фото" data-id="element-495">
              <Camera className="w-4 h-4" data-id="element-496" />
            </button>
          </div>

          <div className="text-center sm:text-left flex-1" data-id="element-497">
            <h2 className="text-2xl font-bold text-slate-900 mb-1" data-id="element-498">
              {data.firstName} {data.lastName}
            </h2>
            <p className="text-slate-500 mb-4" data-id="element-499">
              {'\u0421\u041A "\u0412\u0435\u0440\u0442\u0438\u043A\u0430\u043B\u044C" (\u0425\u0430\u0440\u043A\u0456\u0432), \u0425\u0430\u0440\u043A\u0456\u0432\u0441\u044C\u043A\u0430 \u043E\u0431\u043B\u0430\u0441\u0442\u044C'}
            </p>
            <div className="flex flex-wrap justify-center sm:justify-start gap-2" data-id="element-500">
              <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-blue-50 text-blue-700 border border-blue-100" data-id="element-501">
                UAF-2024-0847
              </span>
              <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-50 text-green-700 border border-green-100" data-id="element-502">
                Активний
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Personal Info Form */}
      <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-[0_4px_24px_rgba(0,0,0,0.04)] border border-slate-100" data-id="element-503">
        <div className="flex items-center justify-between mb-6" data-id="element-504">
          <h3 className="text-lg font-bold text-slate-900 flex items-center gap-2" data-id="element-505">
            <User className="w-5 h-5 text-slate-400" data-id="element-506" />
            Персональна інформація
          </h3>
          {!isEditing ? <button onClick={handleEdit} className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium text-blue-600 border border-blue-200 bg-blue-50 hover:bg-blue-100 transition-colors" data-id="element-507">
              <Edit2 className="w-3.5 h-3.5" data-id="element-508" />
              Редагувати
            </button> : <div className="flex items-center gap-2" data-id="element-509">
              <button onClick={handleSave} className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium text-white transition-colors" style={{
            background: 'linear-gradient(135deg, #3b8fd4, #1d6fa8)'
          }} data-id="element-510">
                <Check className="w-3.5 h-3.5" data-id="element-511" />
                Зберегти
              </button>
              <button onClick={handleCancel} className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium text-slate-600 border border-slate-200 bg-slate-50 hover:bg-slate-100 transition-colors" data-id="element-512">
                <X className="w-3.5 h-3.5" data-id="element-513" />
                Скасувати
              </button>
            </div>}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-514">
          {/* First Name */}
          <FieldRow label="Ім'я" value={data.firstName} editing={isEditing} data-id="element-515">
            <input type="text" className={inputClass} value={draft.firstName} onChange={e => setDraft({
            ...draft,
            firstName: e.target.value
          })} data-id="element-516" />
          </FieldRow>

          {/* Last Name */}
          <FieldRow label="Прізвище" value={data.lastName} editing={isEditing} data-id="element-517">
            <input type="text" className={inputClass} value={draft.lastName} onChange={e => setDraft({
            ...draft,
            lastName: e.target.value
          })} data-id="element-518" />
          </FieldRow>

          {/* Patronymic */}
          <FieldRow label="По батькові" value={data.patronymic} editing={isEditing} data-id="element-519">
            <input type="text" className={inputClass} value={draft.patronymic} onChange={e => setDraft({
            ...draft,
            patronymic: e.target.value
          })} data-id="element-520" />
          </FieldRow>

          {/* Date of Birth */}
          <FieldRow label="Дата народження" value={new Date(data.dob).toLocaleDateString('uk-UA')} editing={isEditing} data-id="element-521">
            <input type="date" className={inputClass} value={draft.dob} onChange={e => setDraft({
            ...draft,
            dob: e.target.value
          })} data-id="element-522" />
          </FieldRow>

          {/* Email — full width */}
          <div className="sm:col-span-2" data-id="element-523">
            <FieldRow label="Електронна пошта" value={data.email} editing={isEditing} data-id="element-524">
              <div data-id="element-525">
                <input type="email" className={inputClass} value={draft.email} onChange={e => setDraft({
                ...draft,
                email: e.target.value
              })} data-id="element-526" />
                <p className="text-xs text-slate-400 mt-1" data-id="element-527">
                  Використовується для входу
                </p>
              </div>
            </FieldRow>
          </div>

          {/* Address — full width */}
          <div className="sm:col-span-2" data-id="element-528">
            <FieldRow label="Поштова адреса" value={data.address} editing={isEditing} data-id="element-529">
              <input type="text" className={inputClass} value={draft.address} onChange={e => setDraft({
              ...draft,
              address: e.target.value
            })} data-id="element-530" />
            </FieldRow>
          </div>
        </div>

        {/* Membership Section */}
        <div className="mt-8 pt-6 border-t border-slate-100" data-id="element-531">
          <h4 className="text-sm font-bold text-slate-700 flex items-center gap-2 mb-5" data-id="element-532">
            <Users className="w-4 h-4 text-slate-400" data-id="element-533" />
            Місцевий осередок
          </h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-534">
            {/* Region */}
            <FieldRow label="Регіон" value={data.region} editing={isEditing} data-id="element-535">
              <div data-id="element-536">
                <select className={selectClass} value={draft.region} onChange={e => setDraft({
                ...draft,
                region: e.target.value
              })} data-id="element-537">
                  {REGIONS.map(r => <option key={r} value={r} data-id="element-538">
                      {r}
                    </option>)}
                </select>
                <p className="text-xs text-slate-400 mt-1 flex items-center gap-1" data-id="element-539">
                  <MapPin className="w-3 h-3" data-id="element-540" />
                  Оберіть область або регіон України
                </p>
              </div>
            </FieldRow>

            {/* Club */}
            <FieldRow label="Клуб" value={data.club} editing={isEditing} data-id="element-541">
              <div data-id="element-542">
                <select className={selectClass} value={draft.club} onChange={e => setDraft({
                ...draft,
                club: e.target.value
              })} data-id="element-543">
                  {CLUBS.map(c => <option key={c} value={c} data-id="element-544">
                      {c}
                    </option>)}
                </select>
                <p className="text-xs text-slate-400 mt-1 flex items-center gap-1" data-id="element-545">
                  <Users className="w-3 h-3" data-id="element-546" />
                  Оберіть клуб зі списку акредитованих організацій ФАіСУ
                </p>
              </div>
            </FieldRow>
          </div>
        </div>

        {/* Sport Qualifications */}
        <div className="mt-8 pt-6 border-t border-slate-100" data-id="element-547">
          <h4 className="text-sm font-bold text-slate-700 flex items-center gap-2 mb-5" data-id="element-548">
            <Award className="w-4 h-4 text-slate-400" data-id="element-549" />
            Спортивна кваліфікація
          </h4>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5" data-id="element-550">
            {/* Alpinism */}
            <FieldRow label="Альпінізм" value={data.rankAlpinism} editing={isEditing} data-id="element-551">
              <select className={selectClass} value={draft.rankAlpinism} onChange={e => setDraft({
              ...draft,
              rankAlpinism: e.target.value
            })} data-id="element-552">
                {SPORT_RANKS.map(r => <option key={r} value={r} data-id="element-553">
                    {r}
                  </option>)}
              </select>
            </FieldRow>

            {/* Rock Climbing */}
            <FieldRow label="Скелелазіння" value={data.rankClimbing} editing={isEditing} data-id="element-554">
              <select className={selectClass} value={draft.rankClimbing} onChange={e => setDraft({
              ...draft,
              rankClimbing: e.target.value
            })} data-id="element-555">
                {SPORT_RANKS.map(r => <option key={r} value={r} data-id="element-556">
                    {r}
                  </option>)}
              </select>
            </FieldRow>

            {/* Ice Climbing */}
            <FieldRow label="Льодолазіння" value={data.rankIceClimbing} editing={isEditing} data-id="element-557">
              <select className={selectClass} value={draft.rankIceClimbing} onChange={e => setDraft({
              ...draft,
              rankIceClimbing: e.target.value
            })} data-id="element-558">
                {SPORT_RANKS.map(r => <option key={r} value={r} data-id="element-559">
                    {r}
                  </option>)}
              </select>
            </FieldRow>
          </div>
        </div>
      </div>

      {/* Security / Password */}
      <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-[0_4px_24px_rgba(0,0,0,0.04)] border border-slate-100" data-id="element-560">
        <h3 className="text-lg font-bold text-slate-900 mb-6 flex items-center gap-2" data-id="element-561">
          <Lock className="w-5 h-5 text-slate-400" data-id="element-562" />
          Безпека
        </h3>

        {!isEditingPassword ? <div data-id="element-563">
            <label className="block text-xs font-semibold text-slate-400 uppercase tracking-wide mb-1.5" data-id="element-564">
              Пароль
            </label>
            <div className="flex items-center justify-between p-3 rounded-xl bg-slate-50 border border-slate-100" data-id="element-565">
              <span className="text-xl leading-none tracking-widest text-slate-400" data-id="element-566">
                ••••••••
              </span>
              <button onClick={() => setIsEditingPassword(true)} className="text-sm font-medium text-blue-600 hover:text-blue-700 transition-colors" data-id="element-567">
                Змінити
              </button>
            </div>
            <p className="text-xs text-slate-400 mt-2" data-id="element-568">
              Останнє оновлення: 3 місяці тому
            </p>
          </div> : <form onSubmit={handlePasswordSubmit} className="space-y-4 max-w-md" data-id="element-569">
            <div data-id="element-570">
              <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-571">
                Поточний пароль
              </label>
              <input type="password" className={inputClass} value={passwordForm.current} onChange={e => setPasswordForm({
            ...passwordForm,
            current: e.target.value
          })} placeholder="Введіть поточний пароль" data-id="element-572" />
            </div>
            <div data-id="element-573">
              <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-574">
                Новий пароль
              </label>
              <input type="password" className={inputClass} value={passwordForm.next} onChange={e => setPasswordForm({
            ...passwordForm,
            next: e.target.value
          })} placeholder="Введіть новий пароль" data-id="element-575" />
            </div>
            <div data-id="element-576">
              <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-577">
                Підтвердження паролю
              </label>
              <input type="password" className={inputClass} value={passwordForm.confirm} onChange={e => setPasswordForm({
            ...passwordForm,
            confirm: e.target.value
          })} placeholder="Повторіть новий пароль" data-id="element-578" />
            </div>
            <div className="flex items-center gap-2 pt-1" data-id="element-579">
              <button type="submit" className="flex items-center gap-2 py-2 px-4 rounded-lg text-white text-sm font-medium transition-colors" style={{
            background: 'linear-gradient(135deg, #3b8fd4, #1d6fa8)'
          }} data-id="element-580">
                <Check className="w-4 h-4" data-id="element-581" />
                Зберегти
              </button>
              <button type="button" onClick={() => setIsEditingPassword(false)} className="flex items-center gap-2 py-2 px-4 rounded-lg bg-slate-100 text-slate-600 text-sm font-medium hover:bg-slate-200 transition-colors" data-id="element-582">
                <X className="w-4 h-4" data-id="element-583" />
                Скасувати
              </button>
            </div>
          </form>}
      </div>
    </div>;
}